<template>
  <div v-if="tag">
    
    <label class="v-label v-text-field v-label--active theme--light" :style="`font-size: 12px; color: ${$dark() ? 'white' : 'black'};`">Stream time</label>
    <div class="v-input v-text-field v-input--is-label-active v-input--is-dirty theme--light">
      <input type="text" v-model.lazy="formatted_stream_time" class="v-input v-text-field v-input--is-dirty theme--light" :style="`color: ${$dark() ? 'white' : 'black'};`">
    </div>
    <v-checkbox label="Active" v-model="state"></v-checkbox>
<!--    <v-text-field label="Stream time" v-model.lazy="formatted_stream_time"></v-text-field>-->
    <v-select v-model="tag.meta.type" placeholder="Select tag type" :items="tag_types" label="Tag type" item-text="name" item-value="id"></v-select>
    <div v-for="field in form_fields">
      <component v-bind:is="get_field_type(field.type)" v-bind="field" v-model="tag.meta" :ref="field.name"></component>
    </div>
    <v-btn color="success" @click="save()">Save</v-btn>
  </div>
</template>

<script>

import SettingsModel from '@/models/settings.js'

import * as FormItems from '@/components/form_items'
import ContentModel from '@/models/content.js'
import TagModel from '@/models/tag.js'

export default {
	props: ["uuid","event_uuid", "position"],

  components: {
    ...FormItems
  }
  ,
  data () {
    var ch = this.$cloudserver.channel("events:tag:"+(this.uuid||"create"));
    return {
      ws_channel: ch,
      tag: undefined,
    }
  },
  methods: {
    get_field_type(field_type) {
      return ContentModel.get_field_type(field_type);
    },
    save() {
      var self = this;
      var tag = _.cloneDeep(this.tag);
      tag.event_uuid = this.event_uuid;

      var tt = _.find(this.tag_types, function(tagtype) {
        return tag.meta.type == tagtype.id;
      });
      if (typeof(tt) != undefined) {
        tag.meta.type_name = tt.value.name;
      }

      this.ws_channel.save({tag: tag}, true)
          .then((msg) => {
            if (typeof(tag.uuid) == "undefined" || tag.uuid == null) {
              self.$message.success("Tag was created!");

            } else {
              self.$message.success("Tag was updated!");
            }
            this.$emit("save");
          })
          .catch((msg) => {
            console.log(msg);
            if (typeof(tag.uuid) == "undefined" || tag.uuid == null) {
              self.$message.warning("Unable to create tag!");
            } else {
              self.$message.warning("Unable to update tag!");
            }
            this.$emit("save_error");
          });

    }
  },
  computed: {
    formatted_stream_time: {
      get () {
        console.log(this.tag.stream_time);
        return TagModel.formatted_stream_time(this.tag);
      },
      set (val) {
        this.tag.stream_time = TagModel.parsed_stream_time(val);
        console.log(this.tag.stream_time);
      }
    },
    state: {
      get () {
        if (this.tag.state == "active") return true;
        return false;
      },
      set (val) {
        if (val == true) {
          this.tag.state = "active";
        } else {
          this.tag.state = "archived";
        }

      }
    },
    tag_types () {
      return SettingsModel.list("tag_form");
    },
    form () {
      if (typeof(this.tag.meta.type) != "undefined") {
        return SettingsModel.get_by_id(this.tag.meta.type)
      }
    },
    form_fields () {
      if (typeof(this.form) == "undefined") return [];
      return this.form["value"]["fields"];
    }
  },
  created() {
    this.ws_channel.join();
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        if(typeof(newVal) != "undefined") {
          this.tag = newVal;
          if (typeof(this.position) != "undefined" && this.tag.stream_time == 0) {
            this.tag.stream_time = Math.round(this.position);
          }
        }
      },
      deep: true
    }
  }
}
</script>
